<template>
  <div
    class="modal fade"
    id="shopperApprovalModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SAM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 35%">{{ lang.SAM001 }}</th>
                  <th class="text-center" style="width: 35%">
                    {{ lang.SAM002 }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ lang.SAM003 }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ lang.SAM004 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(proposal, index) in check.ShopperProposals"
                  :key="proposal.ShopperProposalGuid"
                  :proposal="proposal"
                >
                  <td class="text-left" style="position: relative">
                    <div class="info-btns">
                      <template v-if="proposal.UpdateShopperProposal">
                        <button
                          :id="`updateShopperDataButton-${proposal.ShopperProposalGuid}`"
                          class="btn nopadding"
                          style="border-radius: 50%;"
                          @click="updateShopperData(proposal)"
                        >
                          <i class="material-icons md-24">refresh</i>
                        </button>
                        <b-tooltip
                          ref="tooltip"
                          :target="`updateShopperDataButton-${proposal.ShopperProposalGuid}`"
                          :delay="globals.tooltipDelay"
                        >{{ lang.SPM020 }}</b-tooltip>                        
                      </template>
                      <template v-if="proposal.ShopperPreviousVisited">
                        <i
                          class="material-icons md-24"
                          :id="`ShopperPreviousVisited-${proposal.ShopperProposalGuid}`"
                          style="color: red; cursor: pointer;"
                        >info_outline</i>
                        <b-tooltip
                          ref="tooltip"
                          :target="`ShopperPreviousVisited-${proposal.ShopperProposalGuid}`"
                          :delay="globals.tooltipDelay"
                        >
                          <div class="survey-id-info-tooltip">
                            {{ lang.SAM028 }}
                            <br />
                          </div>
                        </b-tooltip>
                      </template>
                    </div>
                    <div>
                      {{ lang.SAM005 }}:
                      <b>{{ proposal.ShopperId }}</b>
                    </div>
                    <div>
                      {{ lang.SAM006 }} ({{ lang.SAM007 }}):
                      <b>{{ proposal.DisplayName }}</b>
                    </div>
                    <div>
                      {{ lang.SAM008 }}:
                      <b>{{ proposal.Gender }}</b>
                    </div>
                    <div>
                      {{ lang.SAM009 }}:
                      <b>{{ proposal.Distance }} km</b>
                    </div>
                    <div v-show="proposal.Profession">
                      {{ lang.SAM010 }}:
                      <b>{{ proposal.Profession }}</b>
                    </div>
                    <div>
                      {{ lang.SAM012 }}:
                      <b>{{ proposal.CarSegmentName }}</b>
                    </div>
                    <div style="display: flex; align-items: baseline;">
                      {{ lang.SAM011 }}:
                      <select
                        class="form-control"
                        id="newShopperProposalCarModelSelect"
                        v-model="proposal.CarModelGuid"
                        @change="proposal.CompetitorCarModelGuid = ''; updateShopperProposalCarModelAndMatch(proposal)"
                        :disabled="!proposal.CarSegmentGuid"
                      >
                        <option
                          v-for="model in carModelsOfSelectedSegment(proposal.CarSegmentGuid)"
                          :key="model.CarModelGuid"
                          :value="model.CarModelGuid"
                        >
                          {{ model.CarModelName }}
                        </option>
                      </select>
                    </div>
                    <div v-if="check.CompetitorCarModelDistribution" style="display: flex; align-items: baseline;">
                      <span style="text-wrap: nowrap;">{{ lang.SAM030 }}</span>
                      <select
                        class="form-control"
                        id="newShopperProposalCompetitorCarModelSelect"
                        v-model="proposal.CompetitorCarModelGuid"
                        @change="proposal.CarModelGuid = ''; updateShopperProposalCarModelAndMatch(proposal)"
                        :disabled="!proposal.CarSegmentGuid"
                      >
                        <option
                          v-for="model in check.CompetitorCarModelDistribution"
                          :key="model.CompetitorCarModelGuid"
                          :value="model.CompetitorCarModelGuid"
                        >
                        {{ model.CompetitorCarBrand }} {{ model.CompetitorCarModel }}
                        </option>
                      </select>
                    </div>
                    <div>
                      {{ lang.SAM013 }}:
                      <b>{{ proposal.ShopperCar }}</b>
                    </div>
                    <div style="display: flex; align-items: baseline;">
                      <span>{{ lang.SAM014 }}:</span>
                      <select
                        class="form-control"
                        id="newShopperProposalCarMatchSelect"
                        v-model="proposal.CarMatch"
                        @change="updateShopperProposalCarModelAndMatch(proposal)"
                      >
                        <option value="+">+ {{ lang.SAM017 }}</option>
                        <option value="=">= {{ lang.SAM016 }}</option>
                        <option value="-">- {{ lang.SAM015 }}</option>
                      </select>
                    </div>
                    <div>
                      {{ lang.SAM018 }}:
                      <b>{{ proposal.LastUpdatedAt }}</b>
                    </div>
                  </td>
                  <td class="text-left">
                    <div
                      class="comment-type-container"
                      v-if="globals.isLeadAgencyUser || globals.isAdminUser"
                    >
                      <a
                        class="comment-type-header"
                        @click="showFeed(proposal, 'Agency')"
                      >
                        {{ lang.SAM019 }}
                        <i class="material-icons md-24">forum</i>
                      </a>
                      <div
                        class="last-comment-container"
                        v-if="proposal.LastCommentLeadLocal"
                      >
                        <b>{{ proposal.LastCommentLeadLocalCreatedBy }}:</b>
                        {{ globals.truncateString(proposal.LastCommentLeadLocal, 120)}}
                      </div>
                    </div>
                    <div class="comment-type-container">
                      <a
                        class="comment-type-header"
                        @click="showFeed(proposal, 'Audi')"
                      >
                        {{ globals.isAudiUser ? lang.SAM021 : lang.SAM020 }}
                        <i class="material-icons md-24">forum</i>
                      </a>
                      <div
                        class="last-comment-container"
                        v-if="proposal.LastCommentLeadAudi"
                      >
                        <b>{{ proposal.LastCommentLeadAudiCreatedBy }}:</b>
                        {{globals.truncateString(proposal.LastCommentLeadAudi, 120)}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <!-- Lead column -->
                    <div class="form-group" v-if="!(globals.isLeadAgencyUser && userAgencyEqualsCheckAgency)">
                      <select
                        class="form-control"
                        v-model="proposal.AgencyApprovalStatus"
                        @change="updateApprovalState(proposal, 'leadAgency')"
                        :disabled="(!globals.isAudiUser && proposal.MainEntityApprovalStatus) || check.SurveyInstanceStatusId > 200"
                        :class="{
                          'option-green': proposal.AgencyApprovalStatus === 'Approved',
                          'option-red': proposal.AgencyApprovalStatus === 'Rejected',
                          'option-yellow': !proposal.AgencyApprovalStatus,
                        }"
                      >
                        <option class="option-green" :value="'Approved'">
                          {{ lang.SAM022 }}
                        </option>
                        <option class="option-yellow" :value="undefined">
                          {{ lang.SAM023 }}
                        </option>
                        <option class="option-red" :value="'Rejected'">
                          {{ lang.SAM024 }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <!-- Audi column -->
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="proposal.MainEntityApprovalStatus"
                        @change="updateApprovalState(proposal, 'mainEntity')"
                        :disabled="!(globals.isAdminUser || globals.isAudiUser || (globals.isLeadAgencyUser && userAgencyEqualsCheckAgency)) || check.SurveyInstanceStatusId > 200"
                        :class="{
                          'option-green': proposal.MainEntityApprovalStatus === 'Approved',
                          'option-red': proposal.MainEntityApprovalStatus === 'Rejected',
                          'option-yellow': !proposal.MainEntityApprovalStatus,
                        }"
                      >
                        <option
                          class="option-green"
                          :value="'Approved'"
                          v-if="!anyShopperAlreadyApproved || proposal.MainEntityApprovalStatus === 'Approved'"
                        >
                          {{ lang.SAM022 }}
                        </option>
                        <option class="option-yellow" :value="undefined">
                          {{ lang.SAM023 }}
                        </option>
                        <option class="option-red" :value="'Rejected'">
                          {{ lang.SAM024 }}
                        </option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="table-container">
            <table
              class="table outer-table"
            >
              <thead>
                <tr>
                  <th class="nopadding noborder" style="width: 30%"></th>
                  <th class="nopadding noborder" style="width: 70%"></th>
                </tr>
              </thead>
              <tbody>                  
                <tr v-if="statusData.CarDistribution && check.Brand === 'Audi'">
                  <td class="text-left">
                    <b>{{ lang.AWS029 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ lang.AWS030 }}</th>
                          <th>{{ lang.AWS031 }}</th>
                          <th>{{ lang.AWS032 }}</th>
                          <th>{{ lang.AWS026 }}</th>
                          <th>{{ lang.AWS028 }}</th>
                          <th>{{ lang.AWS027 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(model, index) in statusData.CarDistribution"
                          :key="index"
                        >
                          <td>{{ model.CarModelName }}</td>
                          <td>
                            {{ Number((model.SetValue * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ActualValue * 100).toFixed(2)) }} % ({{ model.ApprovedCarCount }})
                          </td>
                          <td>
                            {{ Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2)) }} %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <template v-if="statusData.CompetitorCarDistribution && check.Brand !== 'Audi'">
                  <tr v-for="(competitorCarDistribution, index) in getGroupedCompetitorCars()">
                    <td class="text-left">
                      <b>{{ competitorCarDistribution[0] }} {{ lang.AWS033 }}</b>
                    </td>
                    <td class="text-left">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>{{ lang.AWS030 }}</th>
                            <th>{{ lang.AWS031 }}</th>
                            <th>{{ lang.AWS032 }}</th>
                            <th>{{ lang.AWS026 }}</th>
                            <th>{{ lang.AWS028 }}</th>
                            <th>{{ lang.AWS027 }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(model, index) in competitorCarDistribution[1]" :key="index">
                            <td>{{ model.CompetitorCarModel }}</td>
                            <td>
                              {{ Number((model.SetValue * 100).toFixed(2)) }} %
                            </td>
                            <td>
                              {{ Number((model.ActualValue * 100).toFixed(2)) }} % ({{ model.ApprovedCarCount }})
                            </td>
                            <td>
                              {{ Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2)) }} %
                            </td>
                            <td>
                              {{ Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2)) }} %
                            </td>
                            <td>
                              {{ Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2)) }} %
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.SAM025 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopperApprovalModal",
  props: {
    check: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      statusData: {},
      shopperPreviousVisits: [],
      shopperPreviousVisited: false,
      carSegmentList: [],
      carModelList: [],
      lang: {
        SAM000: "Shopper Approval",
        SAM001: "Shopper",
        SAM002: "Messages",
        SAM003: "Lead Approval",
        SAM004: "Audi / Lead PLUS Approval",
        SAM005: "ShopperID",
        SAM006: "Name",
        SAM007: "Age",
        SAM008: "Gender",
        SAM009: "Distance",
        SAM010: "Profession",
        SAM011: "Model",
        SAM012: "Segment",
        SAM013: "Car",
        SAM014: "Match",
        SAM015: "Downgrade",
        SAM016: "Match",
        SAM017: "Upgrade",
        SAM018: "Last update",
        SAM019: "Agency Channel",
        SAM020: "Audi / Lead agency PLUS Channel",
        SAM021: "Conversation",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        SAM025: "Close",
        SAM026: "Approval updated",
        SAM027: "Approval update failed",
        SAM028: "Shopper already checked the same location in the past!",
        SAM029: "Error while getting shopper who previous visited",
        SAM030: "Competitor Model:",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",

        SPM020: "Update shopper profile data",
      },
    };
  },
  computed: {
    anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return (
        _.findIndex(
          this.check.ShopperProposals,
          (proposal) => proposal.MainEntityApprovalStatus === "Approved"
        ) > -1
      );
    },

    // #2135
    filteredCarModelList() {
      // filter importer specific car models
      var importerSpecificCarModelList = this.carModelList.filter(carModel => carModel.ImporterGuid === this.check.ImporterGuid);
      var filteredList = this.carModelList.filter((carModel) => {
        var keepIt = true;
        importerSpecificCarModelList.forEach(element => {
          if(carModel.CarModelName === element.CarModelName) keepIt = false;
        });
        if(keepIt) return carModel;
      })

      // merge
      filteredList = [...filteredList, ...importerSpecificCarModelList];

      // sort filteredList by CarModelName, ImporterName
      filteredList = filteredList.sort((a, b) => {
        const nameA = a.CarModelName.toUpperCase();
        const nameB = b.CarModelName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        const nameC = a.ImporterName ? a.ImporterName.toUpperCase() : "";
        const nameD = b.ImporterName ? b.ImporterName.toUpperCase() : "";
        if (nameC < nameD) {
          return -1;
        }
        if (nameC > nameD) {
          return 1;
        }

        // name and importer name must be equal
        return 0;
      });

      // remove duplicates
      // keep first of duplicates which has no importer
      var uniqueList = [];
      var isIncluded = false
      filteredList.forEach((element) => {
        isIncluded = false;
        uniqueList.forEach((uniqueElement) => {
          if(uniqueElement.CarModelName === element.CarModelName) isIncluded = true;
        })
        if(!isIncluded) uniqueList.push(element);
      })
      return uniqueList;
    },

    userAgencyEqualsCheckAgency() {
      if(this.check.LeadAgencyGuid) {
        if(this.globals.userAgencyGuid.toLowerCase() == this.check.LeadAgencyGuid.toLowerCase()) return true;        
      } 
      return false;
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  created() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getCarSegmentList((data) => {
      this.carSegmentList = data;
    });
    this.globals.getCarModelList((data) => {
      this.carModelList = data;
    });
  },
  mounted() {
    this.getWaveStatus();
    this.openModal();

    $("#shopperApprovalModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );
  },
  methods: {
    updateShopperData(proposal) {
      let query = `/api/Approval/ShopperProposal/${proposal.ShopperProposalGuid}`;

      $.ajax({
        method: "PATCH",
        url: query,
        dataType: "json",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.SPM023);
          this.$emit("resetData");
        },
        error: (error) => {
          console.error("Error on PATCH in updateShopperData()", error);
          this.globals.showErrorSnackbar(this.lang.SPM024);
        },
      });
    },
    carModelsOfSelectedSegment(guid) {
      return _.filter(this.filteredCarModelList, (model) => {
        return (
          _.findIndex(model.CarSegments,(segment) => segment.CarSegmentGuid === guid) > -1 &&
          _.findIndex(this.check.CarModelDistribution, (audiCars) => audiCars.CarModelGuid === model.CarModelGuid) > -1
        );
      });
    },
    async openModal() {    
      await this.init();
      $("#shopperApprovalModal").modal("show");
    },
    async init() {
      await this.getPreviousVisits();
      this.getLastFeedComments();
      this.check.isWaveLeadAgencyPlus = await this.globals.isWaveLeadAgencyPlus(this.check.WaveGuid);
      for (var i = 0; i < this.check.ShopperProposals.length; i++) {
        this.check.ShopperProposals[i].ShopperPreviousVisited = this.shopperAlreadyChecked(this.check.ShopperProposals[i].ShopperGuid);
      }
      this.$forceUpdate();
    },
    closeModal() {
      $("#shopperApprovalModal").modal("hide");
    },
    showFeed(proposal, type) {
      this.globals.$off("feedModalClosed");
      this.globals.$once("feedModalClosed", (itemGuid, posts) => {
        if (posts[0] && posts[0].Content) {
          if (type === "Audi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          } else {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          }
          this.$forceUpdate();
        }
      });

      let feedName =
        type === "Audi" ? "LeadAgencyAudi" : "LeadAgencyLocalAgency";
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: feedName,
      });
    },
    shopperAlreadyChecked(shopperGuid) {
      if (shopperGuid && this.shopperPreviousVisits.length > 0) {
        for (let i = 0; i < this.shopperPreviousVisits.length; i++) {
          if (shopperGuid === this.shopperPreviousVisits[i].ShopperGuid)
            return true;
        }
        return false;
      } else {
        return false;
      }
    },
    getPreviousVisits() {
      let query = `/api/Shopper/PreviousVisits/${this.check.SurveyInstanceId}`;

      return new Promise((resolve, reject) => {
        $.ajax({
          methode: "GET",
          url: query,
          dataType: "json",
          success: (data) => {
            this.shopperPreviousVisits = data;
            resolve(data);
          },
          error: (error) => {
            console.error("Error on GET in getPreviousVisits()");
            this.globals.showErrorSnackbar(this.lang.SAM029);
            reject(error);
          },
        });
      });
    },
    getLastFeedComments() {
      let requestCount = this.check.ShopperProposals.length;
      if (this.globals.isLeadAgencyUser) requestCount *= 2;

      this.globals.$off("feedPostsReceived");
      this.globals.$on("feedPostsReceived", (itemGuid, feedName, posts) => {
        if (posts[0] && posts[0].Content) {
          let proposal = _.find(
            this.check.ShopperProposals,
            (p) => p.ShopperProposalGuid === itemGuid
          );
          if (feedName === "LeadAgencyAudi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          } else if (feedName === "LeadAgencyLocalAgency") {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy =
              posts[0].FeedPostCreatedBy.Username;
          }
        }

        if (--requestCount <= 0) {
          this.globals.$off("feedPostsReceived");
          this.$forceUpdate();
        }
      });

      for (let proposal of this.check.ShopperProposals) {
        if (this.globals.isLeadAgencyUser || this.globals.isAdminUser)
          this.globals.$emit("requestFeedPosts", {
            ItemGuid: proposal.ShopperProposalGuid,
            FeedType: "ShopperProposal",
            FeedName: "LeadAgencyLocalAgency",
          });
        this.globals.$emit("requestFeedPosts", {
          ItemGuid: proposal.ShopperProposalGuid,
          FeedType: "ShopperProposal",
          FeedName: "LeadAgencyAudi",
        });
      }
    },
    updateApprovalState(proposal, approvalSource) {
      //#1925 Fix for lead agency PLUS approvals
      //if (this.globals.isWaveLeadAgencyPlus(this.check.WaveGuid)) {
      // proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
      //}
      let query = `api/Approval/ShopperApproval/${proposal.ShopperProposalGuid}`;
      let body = {
        ShopperApprovalType: "Reset",
        ShopperApprovalSource: approvalSource,
      };
      let approvalState;
      if (approvalSource === "leadAgency") {
        approvalState = proposal.AgencyApprovalStatus;
        //proposal.MainEntityApprovalStatus = proposal.AgencyApprovalStatus;
      } else {
        approvalState = proposal.MainEntityApprovalStatus;
        //Fix for lead agency plus wave
        if (
          !this.globals.isAudiUser &&
          approvalState != "Rejected" && 
          (this.globals.isLeadAgencyUser && this.userAgencyEqualsCheckAgency)
        )
          proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
        ////Fix for Audi user maybe we need on else if for lead agency PLUS
        ////proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
      }

      if (approvalState === "Approved") body.ShopperApprovalType = "Approve";
      else if (approvalState === "Rejected")
        body.ShopperApprovalType = "Reject";
      $.ajax({
        method: "POST",
        url: query,
        data: JSON.stringify(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            this.$emit("resetData");
            return;
          }
          // if (
          //   this.globals.isAudiUser &&
          //   proposal.AgencyApprovalStatus != "Approved"
          // ) {
          //   proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
          //   this.$emit("resetData");
          // }
          this.$emit("resetData");
          this.globals.showSuccessSnackbar(this.lang.SAM026);
          this.$forceUpdate();
        },
        error: (error) => {
          console.error("Error on POST in updateApprovalState()");
          this.globals.showErrorSnackbar(this.lang.SAM027);
          this.$emit("resetData");
        },
      });
    },
    updateShopperProposalCarModelAndMatch(proposal) {
      $.ajax({
        method: "GET",
        url: "api/Approval/UpdateShopperProposalCarModelAndMatch",
        data: { 
          "shopper-proposal-guid": proposal.ShopperProposalGuid, 
          "car-model-guid": proposal.CarModelGuid, 
          "car-match": proposal.CarMatch,
          "competitor-car-model-guid": proposal.CompetitorCarModelGuid
        },
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar("Approval updated.");
        },
        error: (error) => {
          console.error("Error on POST in updateShopperProposalCarModelAndMatch()");
          this.globals.showErrorSnackbar(error);
        },
      });
    },
    getWaveStatus() {
      if (!this.check.WaveGuid) return;
      let query = `api/ProjectWaves/${this.check.WaveGuid}/AgencyStatus?ApprovalStatus=all`;   

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) this.statusData = data;          
        },
        error: (error) => {
          console.error("Error on GET in getWaveStatus()");
          this.globals.showErrorSnackbar(this.lang.AWS035);
        },
      });
    },
    getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      let carBrandMap = new Map();
      for (let ccd of this.statusData.CompetitorCarDistribution) {
        if (ccd.CompetitorCarBrand !== this.check.Brand) continue;
        if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
          carBrandMap.set(ccd.CompetitorCarBrand, []);
        }
        carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
      }
      return Array.from(carBrandMap);
    }
  },
};
</script>

<style scoped>
.modal-lg {
  width: 1200px;
}
.modal-body {
  padding: 10px;
}
.modal-body > .table-container {
  max-height: calc(100vh - 175px);
  overflow: auto;
}

.table td > .form-group {
  margin: 0 15%;
}
.option-green {
  background-color: rgb(154, 236, 154) !important;
}
.option-yellow {
  background-color: rgb(228, 228, 110) !important;
}
.option-red {
  background-color: rgb(238, 155, 155) !important;
}
.form-group > select.form-control {
  border-radius: 5px;
}
.form-group > select.form-control:disabled {
  opacity: 0.7;
}

.table .btn {
  margin: 5px;
  padding: 2px 10px;
}
.comment-type-header {
  font-weight: bold;
  color: #004080;
  cursor: pointer;
}
.comment-type-container {
  border: 2px solid lightgray;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
  text-align: center;
}
.last-comment-container {
  margin-top: 5px;
  padding: 2px 5px;
  border: 1px solid lightgray;
  border-radius: 5px;
  min-height: 50px;
  text-align: left;
}
.table-container {
  max-height: calc(100vh - 220px);
  overflow: auto;
  margin: 10px 0;
  padding: 0 20px;
}
.info-btns {
  position: absolute;
  right: 5px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// ShopperApprovalModal.vue?20d47276